import request from '@/utils/ajax';

export function addOrUpdateOssConfig(data){
  return request({
    url: `/wx/sys/oss/saveConfig`,
    method: 'POST',
    data: data
  });
}


// ids,
export function deleteConfig(data){
  return request({
    url: `/wx/sys/oss/deleteConfig`,
    method: 'POST',
    data: data
  });
}

export function queryConfigDone(data){
  return request({
    url: `/wx/sys/oss/config`,
    method: 'get',
    params: data
  });
}

/**
 * data需要formData
 * @param data
 * @returns {*}
 */
export function uploadFile(data){
  return request({
    url: `/wx/sys/oss/upload`,
    method: 'post',
    data
  });
}
